<template>
  <div class="card" style="min-height: calc(100vh - 180px)">
    <div class="bg-blue-light p-1">
      <TitleButton
        btnTitle="Add New"
        :showBtn="false"
        :showAddNew="true"
        title="POS Invoice"
        @onClickAddNewButton="navigateToAddPage"
      />
    </div>

    <div class="my-2 px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >

        <div class="col-12 col-sm-6 col-md-2 col-lg-2">
          <label for="colFormLabel" class="col-form-label">Role: </label>
          <v-select
            placeholder="Select Role"
            v-model="selectedRole"
            :options="companyRoles"
            label="name"
            :reduce="name => name.value"
            :clearable="false"
            @update:modelValue="onChangeRole"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
          <label for="colFormLabel" class="col-form-label">Party: </label>
          <AsyncSelect
            ref="partySelect"
            placeholder="Party Name, ID, Mobile No"
            :api-service="fetchContactProfiles"
            :reduce="(name) => name.id"
            v-model="contactProfileId"
            :additional-query="partyQuery"
            :format-label="formatPatientLabel"
          />
        </div>
      </DateQuerySetter>
    </div>
    <div class="col-12 px-2 mt-2">
      <ListTable :purchase="purchaseList" />
    </div>
    <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
  </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import { ref, inject, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import handleContact from "@/services/modules/contact";
import ListTable from "@/components/molecule/company/inventory/electronic-invoice/ListTable.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleRole from "@/services/modules/role";

const DEFAULT_ROLE = 'customer'

const router = useRouter()
const store = useStore()
let offset = ref(20)
let purchaseList = ref([])
let contactProfileId = ref(null)
const companyRoles = ref([])
const selectedRole = ref(null)
const partySelect = ref(null)
const route = useRoute()

const {fetchSalesList} = handlePurchase()
const {fetchContactProfiles} = handleContact();
const {fetchCompanyDefaultRoles} = handleRole();
const {formatPatientLabel} = useAsyncDropdownHelper()

const partyQuery = computed(() => {
  return {roles: selectedRole.value}
})

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})
const page = computed(() => {
  return route.query.page
})

function navigateToAddPage() {
  router.push({name: 'supershop-pos', params: route.params, query:route.query})
}

function getQuery () {
  let query = '?company_id=' + companyId.value
  if(!!contactProfileId.value) query += '&contact_profile_id='+contactProfileId.value
  if(!startDate.value && !endDate.value) return query
  if(startDate.value) query += '&start_date='+startDate.value
  if(endDate.value) query += '&end_date='+endDate.value
  if(page.value) query += '&page='+page.value
  query += '&sale_type=pos_invoice'
  query += '&offset='+offset.value
  return query
}

function syncFilterToRoute() {
  let routeQuery = Object.assign({}, route.query)
  delete routeQuery.contact_profile_id
  if(!!selectedRole.value) routeQuery.role = selectedRole.value
  if(!!contactProfileId.value) routeQuery.contact_profile_id = contactProfileId.value
  router.push({path: route.path, query: routeQuery})
}

function onChangeRole() {
  contactProfileId.value = null
  clearPartyOptions()
  syncFilterToRoute()
  onClickGo()
}

function clearPartyOptions() {
  if(!partySelect.value) return
  partySelect.value.clear()
}

function onClickGo() {
  syncFilterToRoute()
  fetchSalesList(getQuery())
    .then(res => {
      if(res.status) {
        purchaseList.value = res.date.data
        setPagination(res.date)
      }else {
        purchaseList.value = []
        store.commit("resetPagination")
      }

    })
}

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

function onPageChange(page) {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  router.push({path: route.path, query: routeQuery})
  onClickGo()
}

async function getCompanyRoles() {
  const res = await fetchCompanyDefaultRoles('?company_id=' + companyId.value)
  if(!res.data || !res.data.length) return
  companyRoles.value = res.data
  if(!!route.query.role) {
    selectedRole.value = route.query.role
    return
  }
  selectedRole.value = getDefaultRole(res.data)
}

function getDefaultRole(roles) {
  const customerRole = roles.find(role => role.value === DEFAULT_ROLE)
  if(!!customerRole) return customerRole.value
  return roles[0].value
}

onMounted(async () => {
  if(!!route.query.contact_profile_id) contactProfileId.value = Number(route.query.contact_profile_id)
  await getCompanyRoles()
  onClickGo()
})

</script>
